/* eslint-disable no-useless-escape */
import EmojiRegex from 'emoji-regex'
import eaw from 'eastasianwidth'

const regex = /[.][a-zA-Z]*[?]/

export const scrollUp = (element) => {
  const position = element.offset().top - 120
  $('body,html').animate(
    {
      scrollTop: position,
    },
    200,
    'swing'
  )
}

export const numberWithCommas = (number = '') => {
  var parts = number.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const removeURLParameter = (parameter, url) => {
  if (!url) url = window.location.href
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?')
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '='
    var pars = urlparts[1].split(/[&;]/g)

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1)
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
  }

  return url
}
export const collectionPaginate = (pageNumber, handle, url) => {
  if (!url) url = window.location.href

  const query = url.includes('?') ? '?' + url.split('?')[1] : ''
  const base = `/collections/${handle}`
  let pagePart = `p${pageNumber}`
  if (pageNumber == 1) {
    pagePart = ''
  }

  return `${base}/${pagePart}${query}`
}

export const addQueryString = (key, value, url) => {
  if (!url) url = window.location.href

  key = encodeURIComponent(key)
  value = encodeURIComponent(value)

  const exists = getParameterByName(key)
  if (exists) {
    url = removeURLParameter(key, url)
  }

  const queryStringExists = url.includes('?')
  if (queryStringExists) {
    return `${url}&${key}=${value}`
  } else {
    return `${url}?${key}=${value}`
  }
}

// Sizes = { imageSize: number, resolution: number }
export const getShopifyResponsiveUrls = (imgUrl, ...sizes) => {
  if (!imgUrl) {
    return ''
  } else {
    let imageUrls = []

    //Some product images came with the size setted as small, need to remove that.
    if (imgUrl.includes('_small.')) {
      imgUrl = imgUrl.replace('_small.', '.')
    }

    for (let size of sizes) {
      let format = imgUrl.match(regex)
      if (format && format.length == 1) {
        format[0] = `_${size.imageSize}x@2x${format[0]}`
        const newImgUrl = imgUrl.replace(regex, format[0])
        imageUrls.push(`${newImgUrl} ${size.resolution}w`)
      } else {
        return imgUrl
      }
    }

    return imageUrls.join(', ')
  }
}

export const allowNumbersOnly = (e) => {
  let st = String.fromCharCode(e.which)
  if ('0123456789'.indexOf(st, 0) < 0) {
    return false
  }

  return true
}

export const allowNumbersTextOnly = (e) => {
  const emojiRegex = EmojiRegex()
  let st = String.fromCharCode(e.which)
  if (`!$%|^[;:],{*}?_~"\``.includes(st) || emojiRegex.test(st)) {
    return false
  }

  if (e.originalEvent.clipboardData) {
    let pasteValue = e.originalEvent.clipboardData.getData('Text')
    if (
      `!$%|^[;:],{*}?_~"\``.includes(pasteValue) ||
      emojiRegex.test(pasteValue)
    ) {
      return false
    }
  }

  return true
}

export const removeEmojis = (e, error_container, error_id, error_text) => {
  const emojiRegex = EmojiRegex()
  const inputField = e.target
  let myInput = e.target.value
  if (error_id) {
    $('#' + error_id).remove()
    $(e.currentTarget).removeClass('invalid')
  }
  if (emojiRegex.test(myInput)) {
    let newInput = myInput.replace(new RegExp(emojiRegex), '')
    $(inputField).val(newInput)
    if (error_id) {
      $(e.target).addClass('invalid')
      $(error_container).append(`<span id="${error_id}">${error_text}</span>`)
    }
  }
}

export const toASCII = (chars) => {
  const new_text = chars.replace(/[\uff01-\uff5e]/g, function (ch) {
    return String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
  })

  return new_text
}

export const hasFullWidthCharacters = (text) => {
  for (let character of text) {
    if (eaw.characterLength(character) >= 2) {
      return true
    }
  }

  return false
}

export const removeSmallCategories = (tags) => {
  return tags.filter((tag) => {
    return !(
      tag.includes('#') ||
      tag.includes('＃') ||
      tag.includes('SALE') ||
      tag.includes('ignore') ||
      tag.includes('アセンブル') ||
      tag.includes('POS') ||
      tag.includes('カラー:') ||
      tag.includes('テスト') ||
      tag.includes('child_product_inventory') ||
      tag.startsWith('3') ||
      tag == 'sofa' ||
      tag == 'MODERN WORKS' ||
      tag == 'ペールカラー' ||
      tag == 'ニン' ||
      tag == '存在感' ||
      tag == 'discount' ||
      tag == 'towl_bathmat_bathrobe' ||
      tag == '#滑らか' ||
      tag == 'メーネ' ||
      tag == 'bis-paused' ||
      tag == 'not-bis'
    )
  })
}

export const getDaysInMonth = (month, year) => {
  var date = new Date(year, month, 1)
  var days = []
  while (date.getMonth() === month) {
    days.push(new Date(date).getDate())
    date.setDate(date.getDate() + 1)
  }
  return days
}

export const dateFormatFix = (date) => {
  if (date.includes('/')) {
    const dateArray = date.split('T')
    if (dateArray.length == 2) {
      let dateString = dateArray[0]
      dateString = dateString.replace(/\//g, '-')
      let numbersArray = dateString.split('-')

      if (numbersArray.length == 3) {
        const year = numbersArray[0]
        const month = `0${numbersArray[1]}`.slice(-2)
        const day = `0${numbersArray[2]}`.slice(-2)

        date = `${year}-${month}-${day}T${dateArray[1]}`
      }
    }
  }

  return date
}

export const jpDateFormat = (date) => {
  if (date) {
    let finalDate = ''
    if (date.length > 1 && date !== '希望なし' && date !== '指定なし') {
      const year = date.split('年')[0]
      const month = date.split('年')[1].split('月')[0]
      const day = date.split('年')[1].split('月')[1].split('日')[0]
      const formattedDate = year + '-' + month + '-' + day
      finalDate = new Date(formattedDate)
    } else {
      finalDate = 0
    }
    return finalDate
  }
}

export const getDaibikiFee = (total_price) => {
  if (!isNaN(total_price)) {
    total_price = parseInt(total_price)
  }

  if (total_price < 10000) {
    return 330
  } else if (total_price < 30000) {
    return 440
  } else if (total_price < 100000) {
    return 660
  } else {
    return 1100
  }
}

export const validDomain = (domain) => {
  var re = new RegExp(
    /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/
  )
  return !!domain.match(re)
}

export const indexWhere = (array, conditionFn) => {
  return array.findIndex(conditionFn)
}

const getMinutes = (str) => {
  let time = str.split(':')
  return time[0] * 60 + time[1] * 1
}

const getMinutesNow = () => {
  const japanOffset = -32400000 // miliseconds from JST to UTC
  const localOffset = new Date().getTimezoneOffset() * 60000 // ms from local time to UTC
  const timeNow = new Date()
  let absoluteTime = timeNow.getHours() * 60 + timeNow.getMinutes()
  return absoluteTime - (japanOffset - localOffset)
}

export const blockCancelOrder = () => {
  const now = getMinutesNow()
  const startMorning = getMinutes('05:30')
  const endMorning = getMinutes('06:00')
  const startAfterNoon = getMinutes('14:00')
  const endAfterNoon = getMinutes('14:30')
  const startEvening = getMinutes('18:00')
  const endEvening = getMinutes('18:30')
  if (
    (now >= startMorning && now <= endMorning) ||
    (now >= startAfterNoon && now <= endAfterNoon) ||
    (now >= startEvening && now <= endEvening)
  ) {
    return true
  }
  return false
}

export const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key]
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
    return objectsByKeyValue
  }, {})

export const removeNegatives = (value) => {
  let stringVal = value.toString()
  return parseInt(stringVal.replace('-', ''))
}

export const toLocalDate = (date, locale) => {
  const newDate = new Date(date)
  return newDate.toLocaleString(locale)
}

export function keepFocus(header, field) {
  var fieldId = field.replace('#', '')
  document.getElementById(fieldId).setAttribute('autofocus', 'autofocus')
  setTimeout(function () {
    $(header).find(field).focus()
    $(header).find(field).trigger('click')
  }, 200)
}
